import $ from 'jquery'

$.fn.serializeFormJSON = function () {
    var o = {};
    var a = this.serializeArray();
    $.each(a, function () {
        if (o[this.name]) {
            if (!o[this.name].push) {
                o[this.name] = [o[this.name]];
            }
            o[this.name].push(this.value || '');
        } else {
            o[this.name] = this.value || '';
        }
    });
    return o;
};

// JavaScript for disabling form submissions if there are invalid fields
$(document).ready(function() {
    'use strict'

    var $modal = $('#brochureModal');
    var $tabs = $modal.find('.tab');
    var $prev = $modal.find('.btn-prev');
    var $next = $modal.find('.btn-next');

    var passed_mail_code = false;
    var passed_sms_code = false;

    var tracked_events = [];

    var $currentTab = $tabs.first();

    if ($modal.length > 0) {
        $modal[0].addEventListener('show.bs.modal', function () {
            gaEvent('open', 'Opened Modal');
        });
    }

    $modal.find('form').on('submit', function(event) {
        if (!$(this).checkValidity()) {
            event.preventDefault()
            event.stopPropagation()
        }

        $(this).classList.add('was-validated');
    });

    $prev.click(function() {
        nextPrev(-1);
    });
    $next.click(function() {
        nextPrev(1);
    });

    showPrevNextTab(0);

    function nextPrev(n) {
        $currentTab.find('.invalid-feedback').hide();
        $currentTab.find('.invalid-feedback-wrong-input').addClass('d-none');

        $prev.attr('disabled', 'disabled');
        $next.attr('disabled', 'disabled');

        if (n === -1 ) {
            showPrevNextTab(n);

            return;
        }

        if (validateForm() === false) {
            refreshHandlers();

            return false;
        }

        var tab_for = $currentTab.attr('data-tab-for');
        switch (tab_for) {
            case 'first_name':
                $modal.find('span[data-value="first-name"]').html($currentTab.find('input[name="first_name"]').val());
                showPrevNextTab(n);

                gaEvent('finish_tab > ' + tab_for, 'Finished tab > ' + tab_for);

                break;

            case 'organization':
                $modal.find('span[data-value="organization"]').html($currentTab.find('input[name="organization"]').val());
                showPrevNextTab(n);

                gaEvent('finish_tab > ' + tab_for, 'Finished tab > ' + tab_for);

                break;

            case 'email':
                if (passed_mail_code) {
                    showPrevNextTab(n);
                    return;
                }

                $.post(process.env.MIX_API_BASE_URL + 'mail-code/send', $modal.find('form').serializeFormJSON())
                    .done(function(data) {
                        if (data.success) {
                            showPrevNextTab(n);

                            gaEvent('finish_tab > ' + tab_for, 'Finished tab > ' + tab_for);
                        } else {
                            alert('Undefined error!');
                        }
                    })
                    .fail(function(xhr) {
                        if (xhr.status === 422) {
                            $currentTab.find('.invalid-feedback-wrong-input').removeClass('d-none');
                            return;
                        }

                        alert('Undefined error!');
                    })
                    .always(function() {
                        refreshHandlers();
                    });

                break;

            case 'email_code':
                if (passed_mail_code) {
                    showPrevNextTab(n);
                    return;
                }

                $.post(process.env.MIX_API_BASE_URL + 'mail-code/verify', $modal.find('form').serializeFormJSON())
                    .done(function(data) {
                        if (data.success) {
                            passed_mail_code = true;
                            showPrevNextTab(n);

                            gaEvent('finish_tab > ' + tab_for, 'Finished tab > ' + tab_for);
                        } else {
                            alert('Undefined error!');
                        }
                    })
                    .fail(function(xhr) {
                        if (xhr.status === 422) {
                            $currentTab.find('.invalid-feedback-wrong-input').removeClass('d-none');
                            return;
                        }

                        alert('Undefined error!');
                    })
                    .always(function() {
                        refreshHandlers();
                    });
                break;

            case 'phone':
                if (passed_sms_code) {
                    showPrevNextTab(n);
                    return;
                }

                $.post(process.env.MIX_API_BASE_URL + 'sms-code/send', $modal.find('form').serializeFormJSON())
                    .done(function(data) {
                        if (data.success) {
                            showPrevNextTab(n);

                            gaEvent('finish_tab > ' + tab_for, 'Finished tab > ' + tab_for);
                        } else {
                            alert('Undefined error!');
                        }
                    })
                    .fail(function(xhr) {
                        if (xhr.status === 422) {
                            $currentTabtime_frame.find('.invalid-feedback-wrong-input').removeClass('d-none');
                            return;
                        }

                        alert('Undefined error!');
                    })
                    .always(function() {
                        refreshHandlers();
                    });
                break;

            case 'sms_code':
                if (passed_sms_code) {
                    showPrevNextTab(n);
                    return;
                }

                $.post(process.env.MIX_API_BASE_URL + 'sms-code/verify', $modal.find('form').serializeFormJSON())
                    .done(function(data) {
                        if (data.success) {
                            passed_sms_code = true;
                            showPrevNextTab(n);

                            gaEvent('finish_tab > ' + tab_for, 'Finished tab > ' + tab_for);
                        } else {
                            alert('Undefined error!');
                        }
                    })
                    .fail(function(xhr) {
                        if (xhr.status === 422) {
                            $currentTab.find('.invalid-feedback-wrong-input').removeClass('d-none');
                            return;
                        }

                        alert('Undefined error!');
                    })
                    .always(function() {
                        refreshHandlers();
                    });
                break;

            case 'time_frame':
                var timeFrameVal = $currentTab.find('input[name="time_frame"]:checked').val();

                if (timeFrameVal === '-1') { // already has eLearning
                    showPrevNextTab(n);
                } else {
                    // skip last step because user has no eLearning
                    showPrevNextTab(n);
                    showPrevNextTab(n);
                }

                gaEvent('finish_tab > ' + tab_for, 'Finished tab > ' + tab_for);
                break;

            case 'comments':
                // finish form, last step.

                $.post(process.env.MIX_API_BASE_URL + 'brochure', $modal.find('form').serializeFormJSON())
                    .done(function(data) {
                        if (data.success) {
                            showPrevNextTab(n);
                            removeHandlers();

                            gaEvent('finish_funnel', 'Finished funnel');
                        } else {
                            alert('Undefined error!');
                        }
                    })
                    .fail(function(xhr) {
                        alert('Undefined error!');
                    })
                    .always(function() {
                        refreshHandlers();
                    });

                break;

            default:
                showPrevNextTab(n);
                gaEvent('finish_tab > ' + tab_for, 'Finished tab > ' + tab_for);

                break;
        }
    }

    function showPrevNextTab(n) {
        // if n === 0 display first tab
        if (n === 0) {
            $currentTab.show();

            refreshHandlers();

            return;
        }

        var $nextVisibleTab;
        if (n === -1) {
            $nextVisibleTab = $currentTab.prev('.tab');
        } else {
            $nextVisibleTab = $currentTab.next('.tab');
        }

        if ($nextVisibleTab.length === 0) {
            refreshHandlers();

            return;
        }

        $currentTab.hide();
        $nextVisibleTab.show();

        $currentTab = $nextVisibleTab;

        refreshHandlers();
    }

    function refreshHandlers() {
        $prev.show();
        $next.show();

        $prev.removeAttr('disabled');
        $next.removeAttr('disabled');

        if ($currentTab.attr('data-tab-for') === $tabs.first().attr('data-tab-for')) {
            $prev.hide();
        }

        if ($currentTab.attr('data-tab-for') === $tabs.last().attr('data-tab-for')) {
            $prev.hide();
            $next.hide();
        }
    }

    function removeHandlers() {
        $prev.hide();
        $next.hide();
    }

    function validateForm() {
        var valid = true;

        $currentTab.find('input[required]')
            .each(function() {
                if ($(this).val() === "") {
                    $(this).parents('.form-group').find('.invalid-feedback').show();

                    valid = false;
                }
            });

        return valid; // return the valid status
    }

    function gaEvent(eventAction, eventLabel) {
        if (tracked_events.includes(eventAction)) {
            return; // already tracked
        }

        if (typeof gtag !== 'function') {
            console.log('gtag not a function!');
            return; // stop if gtag is not a function
        }

        gtag('event', 'BrochureModal', {
            'event_category': 'BrochureModal',
            'event_label': eventLabel
        });

        tracked_events.push(eventAction);
    }

});
